// City guide → "Before you go": this week's weather, plugs / currency / tipping / emergency number, and a packing list.
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function TripPrepCard({ city, country }) {
  const [p, setP] = useState(null);
  useEffect(() => {
    let on = true;
    api("/travel/prep?city=" + encodeURIComponent(city) + (country ? "&country=" + encodeURIComponent(country) : ""), { auth: false })
      .then((r) => { if (on) setP(r); }).catch(() => {});
    return () => { on = false; };
  }, [city, country]);
  if (!p) return null;
  const e = p.essentials;
  return (
    <section className="mx-auto max-w-7xl px-4 py-8 sm:px-6" data-testid="trip-prep" aria-labelledby="prep-title">
      <h2 id="prep-title" className="text-2xl font-bold tracking-tight">Before you go</h2>
      {p.weather.days.length ? (
        <div className="mt-4 flex gap-2 overflow-x-auto pb-2" aria-label="Weather this week">
          {p.weather.days.map((d) => (
            <div key={d.date} className="min-w-[72px] rounded-2xl border p-3 text-center">
              <p className="text-xs font-semibold text-muted-foreground">{new Date(d.date + "T12:00:00").toLocaleDateString("en-GB", { weekday: "short", day: "numeric" })}</p>
              <p className="mt-1 text-lg font-bold">{d.max != null ? Math.round(d.max) + "°" : "–"}</p>
              <p className="text-xs text-muted-foreground">{d.min != null ? Math.round(d.min) + "°" : ""}{(d.rain_chance || 0) >= 50 ? " · rain" : ""}</p>
            </div>
          ))}
        </div>
      ) : null}
      <div className="mt-4 grid gap-4 md:grid-cols-2">
        {e ? (
          <dl className="grid grid-cols-[110px_1fr] gap-x-4 gap-y-2 rounded-2xl border p-5 text-sm">
            <dt className="font-semibold">Plugs</dt><dd>Type {e.plugs} · {e.volts}V</dd>
            <dt className="font-semibold">Currency</dt><dd>{e.currency}</dd>
            <dt className="font-semibold">Emergency</dt><dd>{e.emergency}</dd>
            <dt className="font-semibold">Driving</dt><dd>On the {e.drive}</dd>
            <dt className="font-semibold">Tipping</dt><dd>{e.tipping}</dd>
          </dl>
        ) : null}
        <div className="rounded-2xl border p-5 text-sm">
          <p className="font-semibold">Pack for this week</p>
          <ul className="mt-2 list-disc space-y-1 pl-5">
            {p.packing.flatMap((g) => g.items).slice(0, 10).map((i) => <li key={i}>{i}</li>)}
          </ul>
        </div>
      </div>
      <p className="mt-3 text-xs text-muted-foreground">Weather from Open-Meteo. Check GOV.UK foreign travel advice for entry rules.</p>
    </section>
  );
}
